import { useRef, useState } from "react"

export function useImageUload(src: string){

    const [picUrlState, setPicUrlState] = useState<string|null>(src)
    const imgInputRef = useRef<HTMLInputElement>(null)

    function removePic(){
        setPicUrlState(null)
    }

    function selectImage(){
        imgInputRef.current?.click()
    }

    function handleSelection(e: any): File{
        const file = e.target.files[0]
        setPicUrlState(URL.createObjectURL(file))
        return file
    }

    return {
        picUrlState,
        setPicUrlState,
        imgInputRef,
        handleSelection,
        selectImage,
        removePic
    }

}